import React, { useEffect } from "react";
import AOS from "aos";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import Preloader from "../components/sections/Preloader";
import PageTitle from "../components/sections/PageTitle";
import ScrollTop from "../components/sections/ScrollTop";
import "../styles/about.css";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <div className="wrapper page-about">
      <Preloader />
      <Menu />
      <PageTitle title="About us" breadcrumbs={[{ label: "About us" }]} />

      <section className="about s2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center pd-0">
                <h6 className="sub-heading">
                  <span>About us</span>
                </h6>
                <h3 className="heading" data-aos="fade-up">
                  CVMech NFT - Free Mint But Real Value
                </h3>
              </div>

              <div className="about__main center">
                <img src="/images/layouts/about-06.png" alt="About" />
                <p className="mb-17">
                  CVMech is the key access for holders to the vault of $10k+thru
                  ecosystem!
                </p>
                <p className="mb-30">
                  Every CVMech is hand-drawn by Hy, the CVPad artist who helped
                  shape our visual style. With more than 100 hours of work put
                  into the collection, each NFT shows a modern robot mascot
                  filled with human emotions and seasonal themes.
                </p>
                <a
                  href="https://raydium.io/swap/?inputMint=sol&outputMint=8TC4ZJA5cwB5gmLemBfPP95v1Mft82kHGF9a87kepNno"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="action-btn"
                >
                  <span>Get WL Now</span>
                </a>
                <p className="wl-note mt-20">
                  Hold 20 000 $CVAI = Guaranteed Whitelist Spot
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollTop />
    </div>
  );
};

export default About;
